// DocForm — the one shell of the card's document forms (INVOICE-FORM-UX §4.2): «Новый инвойс»,
// «Редактировать черновик», «Прямая выплата», «Расторжение договора». A pinned head (the title, the
// payment-type chip, the X), a body and a pinned foot with the actions. The controller owns every
// field, query and mutation and hands its buttons in as `actions`.
//
// Two hosts. `inline` (default): in flow inside the card's Документы pane — head and foot stick to
// the pane, and the shell scrolls itself into view once, on mount. `overlay`: the same shell centred
// over a fixed scrim; only the dead /ambassadors/:id page still asks for it (CreateInvoiceModal's
// default host).
//
// Closing is the X and the controller's «Отмена»: both call `onClose` and are disabled together
// (`closeDisabled`). Deliberately nothing else — the root is a plain div (Enter submits nothing),
// there is no key listener and the scrim has no click handler.
import { useEffect, useRef } from 'react';
import { Button, Icon } from './ds';
import './doc-form.css';

export default function DocForm({ title, meta, onClose, closeDisabled = false, actions, host = 'inline', children }) {
  const ref = useRef(null);
  // Inline only, once: the trigger may sit a screen above or below the slot the form mounts in.
  useEffect(() => {
    if (host === 'inline') ref.current?.scrollIntoView({ block: 'start' });
  }, []); // mount-only

  const shell = (
    <div ref={ref} className={`doc-form doc-form--${host}`}>
      <div className="doc-form__head">
        <h3 className="doc-form__title" title={title}>{title}</h3>
        {meta && <span className="doc-form__meta" title={meta}>{meta}</span>}
        <Button
          hierarchy="tertiary"
          size="small"
          iconOnly
          className="doc-form__close"
          aria-label="Закрыть"
          disabled={closeDisabled}
          onClick={onClose}
        >
          <Icon name="x" size="sm" />
        </Button>
      </div>
      <div className="doc-form__body">{children}</div>
      <div className="doc-form__foot">{actions}</div>
    </div>
  );
  return host === 'overlay' ? <div className="doc-form-overlay outcrm-scope">{shell}</div> : shell;
}
